import {ComponentType} from "react";

import {Contact} from "../../../components/views/Contact";
import {Faq} from "../../../components/views/Faq";
import {Added} from "../../../features/analytical_platform/views/Added";
import {Dashboard} from "../../../features/analytical_platform/views/Dashboard";
import {Demand} from "../../../features/analytical_platform/views/Demand";
import {FLTR} from "../../../features/analytical_platform/views/FLTR";
import {Home} from "../../../features/analytical_platform/views/Home";
import {LocationSummary} from "../../../features/analytical_platform/views/LocationSummary";
import {Offer} from "../../../features/analytical_platform/views/Offer";
import {Prices} from "../../../features/analytical_platform/views/Prices";
import {Sold} from "../../../features/analytical_platform/views/Sold";
import {Error404} from "../../../features/errors/views/Error404";
import {Landing} from "../../../features/landing/views/Landing";
import {AnalyticalPlatformLanding} from "../../../features/landing_analytical_platform/views/Landing";
import {MonitoringLanding} from "../../../features/monitoring/views/MonitoringLanding";
import {ArticleDetails} from "../../../features/newshub/views/ArticleDetails";
import {BigDataArticleDetails} from "../../../features/newshub/views/BigDataArticleDetails";
import {BigDataNews} from "../../../features/newshub/views/BigDataNews";
import {MarketInformation} from "../../../features/newshub/views/MarketInformation";
import {NewshubLanding} from "../../../features/newshub/views/NewshubLanding";
import {Contact as PressContact} from "../../../features/newshub/views/press_office/Contact";
import {ExpertDetails} from "../../../features/newshub/views/press_office/ExpertDetails";
import {Experts} from "../../../features/newshub/views/press_office/Experts";
import {MediaMaterials} from "../../../features/newshub/views/press_office/MediaMaterials";
import {PressInformation} from "../../../features/newshub/views/press_office/PressInformation";
import {PressInformationDetails} from "../../../features/newshub/views/press_office/PressInformationDetails";
import {PressReview} from "../../../features/newshub/views/press_office/PressReview";
import {PressReviewDetails} from "../../../features/newshub/views/press_office/PressReviewDetails";
import {Pricing} from "../../../features/pricing/views/Pricing";
import {PublicationDetails} from "../../../features/publications/views/PublicationDetails";
import {PublicationsLanding} from "../../../features/publications/views/PublicationsLanding";
import {PublicationsListing} from "../../../features/publications/views/PublicationsListing";
import {ChangePassword} from "../../../features/users/views/ChangePassword";
import {ResetPassword} from "../../../features/users/views/ResetPassword";
import {UserEdit} from "../../../features/users/views/UserEdit";
import {chartsRoutes} from "./charts_routes";

export interface IRoute {
    path: string | string[];
    exact: boolean;
    component: ComponentType;
}

export const routes: IRoute[] = [
    {
        path: [chartsRoutes.pl.root, chartsRoutes.en.root],
        exact: true,
        component: Landing
    },
    {
        path: [chartsRoutes.pl.solutionsAnalyticalPlatform, chartsRoutes.en.solutionsAnalyticalPlatform],
        exact: true,
        component: AnalyticalPlatformLanding
    },
    {
        path: [chartsRoutes.pl.pricing, chartsRoutes.en.pricing],
        exact: true,
        component: Pricing
    },
    {
        path: [chartsRoutes.pl.properties.root, chartsRoutes.en.properties.root],
        exact: true,
        component: Home
    },
    {
        path: [chartsRoutes.pl.flats.root, chartsRoutes.en.flats.root],
        exact: true,
        component: Home
    },
    {
        path: [chartsRoutes.pl.flats.fltr, chartsRoutes.en.flats.fltr],
        exact: true,
        component: FLTR
    },
    {
        path: [chartsRoutes.pl.houses.root, chartsRoutes.en.houses.root],
        exact: true,
        component: Home
    },
    {
        path: [chartsRoutes.pl.properties.city.root, chartsRoutes.en.properties.city.root],
        exact: true,
        component: Dashboard
    },
    {
        path: [chartsRoutes.pl.flats.city.root, chartsRoutes.en.flats.city.root],
        exact: true,
        component: Dashboard
    },
    {
        path: [chartsRoutes.pl.houses.city.root, chartsRoutes.en.houses.city.root],
        exact: true,
        component: Dashboard
    },
    {
        path: [
            chartsRoutes.pl.properties.city.locationSummary,
            chartsRoutes.en.properties.city.locationSummary,
            chartsRoutes.pl.flats.city.locationSummary,
            chartsRoutes.en.flats.city.locationSummary,
            chartsRoutes.pl.houses.city.locationSummary,
            chartsRoutes.en.houses.city.locationSummary
        ],
        exact: true,
        component: LocationSummary
    },
    {
        path: [
            chartsRoutes.pl.properties.city.prices,
            chartsRoutes.en.properties.city.prices,
            chartsRoutes.pl.flats.city.prices,
            chartsRoutes.en.flats.city.prices
        ],
        exact: true,
        component: Prices
    },
    {
        path: [
            chartsRoutes.pl.properties.city.offer,
            chartsRoutes.en.properties.city.offer,
            chartsRoutes.pl.flats.city.offer,
            chartsRoutes.en.flats.city.offer
        ],
        exact: true,
        component: Offer
    },
    {
        path: [chartsRoutes.pl.properties.city.demand, chartsRoutes.en.properties.city.demand],
        exact: true,
        component: Demand
    },
    {
        path: [chartsRoutes.pl.flats.city.demand, chartsRoutes.en.flats.city.demand],
        exact: true,
        component: Demand
    },
    {
        path: [chartsRoutes.pl.properties.city.sold, chartsRoutes.en.properties.city.sold],
        exact: true,
        component: Sold
    },
    {
        path: [chartsRoutes.pl.flats.city.sold, chartsRoutes.en.flats.city.sold],
        exact: true,
        component: Sold
    },
    {
        path: [chartsRoutes.pl.properties.city.added, chartsRoutes.en.properties.city.added],
        exact: true,
        component: Added
    },
    {
        path: [chartsRoutes.pl.flats.city.added, chartsRoutes.en.flats.city.added],
        exact: true,
        component: Added
    },
    {
        path: [chartsRoutes.pl.contact, chartsRoutes.en.contact],
        exact: true,
        component: Contact
    },
    {
        path: [chartsRoutes.pl.faq, chartsRoutes.en.faq],
        exact: true,
        component: Faq
    },
    {
        path: [chartsRoutes.pl.user.changePassword, chartsRoutes.en.user.changePassword],
        exact: true,
        component: ChangePassword
    },
    {
        path: [chartsRoutes.pl.user.edit, chartsRoutes.en.user.edit],
        exact: true,
        component: UserEdit
    },
    {
        path: [chartsRoutes.pl.resetPassword, chartsRoutes.en.resetPassword],
        exact: false,
        component: ResetPassword
    },
    {
        path: [chartsRoutes.pl.monitoring.root, chartsRoutes.en.monitoring.root],
        exact: true,
        component: MonitoringLanding
    },
    {
        path: [chartsRoutes.pl.publications.root],
        exact: true,
        component: PublicationsLanding
    },
    {
        path: [chartsRoutes.pl.publications.listing],
        exact: true,
        component: PublicationsListing
    },
    {
        path: [chartsRoutes.pl.publications.details],
        exact: true,
        component: PublicationDetails
    },
    {
        path: [chartsRoutes.pl.newshub.root],
        exact: true,
        component: NewshubLanding
    },
    {
        path: [chartsRoutes.pl.newshub.marketInformation.details],
        exact: true,
        component: ArticleDetails
    },
    {
        path: [
            chartsRoutes.pl.newshub.marketInformation.root,
            chartsRoutes.pl.newshub.marketInformation.category.root,
            chartsRoutes.pl.newshub.marketInformation.category.vendor,
            chartsRoutes.pl.newshub.marketInformation.category.subcategory.root,
            chartsRoutes.pl.newshub.marketInformation.category.subcategory.vendor
        ],
        exact: true,
        component: MarketInformation
    },
    {
        path: [chartsRoutes.pl.newshub.bigDataNews.root],
        exact: true,
        component: BigDataNews
    },
    {
        path: [chartsRoutes.pl.newshub.bigDataNews.details],
        exact: true,
        component: BigDataArticleDetails
    },
    {
        path: [chartsRoutes.pl.pressOffice.root, chartsRoutes.en.pressOffice.root],
        exact: true,
        component: PressInformation
    },
    {
        path: [chartsRoutes.pl.pressOffice.pressReview.root, chartsRoutes.en.pressOffice.pressReview.root],
        exact: true,
        component: PressReview
    },
    {
        path: [chartsRoutes.pl.pressOffice.experts.root, chartsRoutes.en.pressOffice.experts.root],
        exact: true,
        component: Experts
    },
    {
        path: [chartsRoutes.pl.pressOffice.experts.details, chartsRoutes.en.pressOffice.experts.details],
        exact: true,
        component: ExpertDetails
    },
    {
        path: [chartsRoutes.pl.pressOffice.mediaMaterials, chartsRoutes.en.pressOffice.mediaMaterials],
        exact: true,
        component: MediaMaterials
    },
    {
        path: [chartsRoutes.pl.pressOffice.contact, chartsRoutes.en.pressOffice.contact],
        exact: true,
        component: PressContact
    },
    {
        path: [
            chartsRoutes.pl.pressOffice.pressInformation.details,
            chartsRoutes.en.pressOffice.pressInformation.details
        ],
        exact: true,
        component: PressInformationDetails
    },
    {
        path: [chartsRoutes.pl.pressOffice.pressReview.details, chartsRoutes.en.pressOffice.pressReview.details],
        exact: true,
        component: PressReviewDetails
    },
    {
        path: "*",
        exact: false,
        component: Error404
    }
];
